import { render, staticRenderFns } from "./TopSideMenu.vue?vue&type=template&id=503b6ef0"
import script from "./TopSideMenu.vue?vue&type=script&lang=js"
export * from "./TopSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports